<template>
  <div>
    <el-radio-group v-model="copierFormData.type" @change="changeCopierOptions">
      <el-radio
        v-for="item in copierOptions"
        :key="item.itemCode"
        :label="item.itemCode"
        class="approve-radio"
      >{{item.itemName}}</el-radio>
    </el-radio-group>

    <!-- 说明 -->
    <el-divider></el-divider>
    <p style="font-size:14px;line-height:30px;">{{copierOptionsNote}}</p>

    <el-divider></el-divider>
    <div class="select-notifier">
      <p class="form-label">选择抄送人：</p>
      <select-people
        v-if="selectNotifierWidgetStatus"
        @byEmployee="setEmployees"
        @byDepartment="setDepartment"
        :defaultVal="defaultSelected"
        :onlySelectEmployee="onlySelectEmployee"
      ></select-people>
    </div>
  </div>
</template>

<script>
import {
  copierOptions,
  initNodeForm,
  operatorSelectTypes
} from "../approval/approvalConfig";

export default {
  props: {
    currentEditNode: {
      type: Object
    },
    moddle: {
      type: Object
    }
  },
  computed: {
    defaultSelected() {
      return this.defaultEmployees.concat(this.defaultDepartments);
    },

    copierOptionsNote() {
      return copierOptions.find(
        item => item.itemCode === this.copierFormData.type
      ).describe;
    },

    onlySelectEmployee() {
      return this.copierFormData.type === "presetEmployee";
    }
  },
  data() {
    return {
      copierFormData: this.$js.deepClone(initNodeForm.Copy),
      copierOptions: copierOptions,

      defaultEmployees: [],
      defaultDepartments: [],
      employees: [],
      departments: [],

      selectNotifierWidgetStatus: true
    };
  },
  methods: {
    changeCopierOptions(type) {
      this.resetSelectEmployee();
      this.copierFormData.type = type;
    },

    setEmployees(employees) {
      this.employees = employees;
    },

    setDepartment(departments) {
      this.departments = departments;
    },

    initFormData(initData) {
      this.copierFormData.type = initData.type || "presetEmployee";
      this.defaultEmployees = initData.employeeRange.map(item => ({
        id: item.id,
        name: item.employeeName,
        type: 1
      }));
      this.defaultDepartments = initData.departmentRange.map(item => ({
        id: item.id,
        name: item.departmentName,
        type: 0
      }));
    },

    resetSelectNotifierWidget() {
      this.selectNotifierWidgetStatus = false;
      this.$nextTick(() => {
        this.selectNotifierWidgetStatus = true;
      });
    },

    resetSelectEmployee() {
      this.defaultEmployees = [];
      this.defaultDepartments = [];
      this.resetSelectNotifierWidget();
    },

    createdBpmnSetting() {
      this.currentEditNode.set(
        "flowable:delegateExpression",
        "${copierDelegate}"
      );
      delete this.currentEditNode["type"];
    },

    getDocument() {
      const properties = {
        employeeRange: this.employees.map(item => ({
          employeeName: item.name,
          id: item.id
        })),
        departmentRange: this.departments.map(item => ({
          departmentName: item.name,
          id: item.id
        })),
        type: this.copierFormData.type
      };
      return properties
    },

    getShowText() {
      if (this.copierFormData.type === "initiatorAssignee") {
        return "由制单人指定"
      }

      if (this.copierFormData.type === "presetEmployee") {
        const employee = this.employees.map(item => item.name);

        const department = this.departments.map(item => item.name);

        return employee.concat(department).join();
      }

      return "";
    },

    /**
     * bpmn XML 设置
     */
    clearBpmnSetting(bpmnNode) {
      delete bpmnNode.documentation;
    }
  }
};
</script>

<style>
.form-label {
  font-size: 14px;
  float: left;
  margin-right: 10px;
}
.select-notifier {
  height: 50px;
  line-height: 50px;
}
</style>
